if (window && window.__webpack_asset_path) { //eslint-disable-line
    __webpack_public_path__ = window['__webpack_asset_path']; //eslint-disable-line
}

import 'console-shim';
import React from 'react';
import ReactDOM from 'react-dom';
import root from 'window-or-global';
import {BrowserRouter} from 'react-router-dom';
import alt from './alt';
import {setLocale} from 'epic-common/src/locale';
import ScrollToTopOnUpdate from 'epic-react-common/src/components/ScrollToTopOnUpdate';
import App from './App';

/**
 * The react app will look for a DOM element with this ID and insert itself there.
 */
const reactDomEle = document.getElementById('battleBreakersWrapper');
const renderClient = function renderClient() {
    ReactDOM.hydrate((
        <BrowserRouter>
            <ScrollToTopOnUpdate>
                <App />
            </ScrollToTopOnUpdate>
        </BrowserRouter>
    ), reactDomEle);
};

// only proceed if the react ele exists
if (reactDomEle) {
    if (root.__epic_client_state) {
        setLocale(root.__locale);
        alt.bootstrap(root.__epic_client_state);
    }
    renderClient();
}
